import { useFormatter } from "use-intl";
import { DateFormatter, DateTimeFormatter } from "@/shared/formatters";
import { useYesOrNo } from "@/shared/typography";
import { BoxedValue } from "../model/types";

/**
 * Дефолтный вид обёрнутого скаляра: обёртка снимается здесь, а не в хуке,
 * и значение сразу уходит в штатный форматтер своего типа.
 */
export function BoxedValueView({ data }: { data: BoxedValue }) {
  const format = useFormatter();
  const yesOrNo = useYesOrNo();

  switch (data.__typename) {
    case "StringValue":
      return <span>{data.value}</span>;
    case "BooleanValue":
      return <span>{yesOrNo(data.value)}</span>;
    case "IntValue":
      return <span>{format.number(data.value)}</span>;
    case "DecimalValue":
      return <span>{format.number(Number(data.value))}</span>;
    case "DateValue":
      return <DateFormatter value={data.value} />;
    case "DateTimeValue":
      return <DateTimeFormatter value={new Date(data.value)} />;
    default:
      return <span>{String(data.value)}</span>;
  }
}
